@if (authority && body && dossier) {
	<div class="container p-3">
		<it-breadcrumb>
			<it-breadcrumb-item
				><a routerLink="/">{{
					"it.navigation.home" | translate
				}}</a></it-breadcrumb-item
			>
			<it-breadcrumb-item
				><a
					routerLink="/dossiers"
					[queryParams]="{ authority: body.id }"
					>{{ body.label["iterlex.currentLanguage" | translate] }}</a
				></it-breadcrumb-item
			>
			<it-breadcrumb-item>
				{{ dossier.title }}
			</it-breadcrumb-item>
		</it-breadcrumb>
	</div>
	<div class="container p-3">
		<div class="d-flex align-items-center">
			<h1>{{ "iterlex.stats" | translate }} {{ dossier.title }}</h1>
		</div>
		<p>
			{{ dossierType?.label?.[("iterlex.currentLanguage" | translate)] }}
			({{ "iterlex.dossier-state-" + dossier.state | translate }}),
			{{ "iterlex.number" | translate }} {{ dossier.number }},
			{{ (dossier.date | date: "d/M/yyyy") ?? dossier.date }}
		</p>
	</div>
	<div class="container p-3">
		<h2>{{ "iterlex.stats-amendments" | translate }}</h2>
		@if (dataAmendmentsPerType.length > 0) {
			<h3>{{ "iterlex.stats-amendments-types" | translate }}</h3>
			<app-histogram [data]="dataAmendmentsPerType" />
		}
		@if (dataAmendmentsPerArticle.length > 0) {
			<h3>{{ "iterlex.stats-amendments-articles" | translate }}</h3>
			<app-histogram [data]="dataAmendmentsPerArticle" />
		}
	</div>
}
